import React from "react";
import { Routes } from "react-router-dom";
import AuthRouter from "./auth/AuthRouter";

const Router = () => {
  return <Routes>{AuthRouter()}</Routes>;
};
export default Router;
